import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Diagnostico } from './pages/Diagnostico';
import { useScreenInit } from './useScreenInit';
function AppContent() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-arena font-body text-carbon" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/diagnostico" element={<Diagnostico data-id="element-7" />} data-id="element-6" />
        </Routes>
      </main>
      <Footer data-id="element-8" />
    </div>;
}
export function App() {
  return <Router data-id="element-9">
      <AppContent data-id="element-10" />
    </Router>;
}